import { useGetMe } from "./useUsers";

export function useGetUserAccessLevel(): number {
  const { data: me, isLoading: loadingMe } = useGetMe();

  let accessLevel = -1; // -1 to indicate that the access level is not yet determined since 0 is endusers.

  if (!loadingMe && me) {
    accessLevel = me.accessLevel;
  }

  return accessLevel;
}
